const cleanComment = comment => {
  // remove back slash
  const str = comment ? comment.replace(/\\/g, '') : '';
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
};

export default cleanComment;
